const COMPARE_AT_PRICE = '_compare_at_price';

class CartFetchError extends Error {
    constructor(message, cartItem) {
        super(message);
        this.name = 'CartFetchError';

        if (cartItem instanceof CartItem) {
            this.cartItem = cartItem;
        }
    }
}

class CartItem {
    constructor(lineNumber, key, variantId, originalPrice, properties, quantity, title, options) {
        this.lineNumber = Number.parseInt(lineNumber);
        this.key = key;
        this.variantId = Number.parseInt(variantId);
        const parsedOriginalPrice = Number.parseInt(originalPrice);
        this.compareAtPrice = (Number.isNaN(parsedOriginalPrice)) ? null : parsedOriginalPrice;
        this.properties = properties;
        this.quantity = quantity;
        this.title = title;
        this.options = options;
    }

    addProperty(key, value) {
        const newProperties = { ...this.properties, [key]: value };
        return new CartItem(
            this.lineNumber,
            this.key,
            this.variantId,
            this.compareAtPrice,
            newProperties,
            this.quantity,
            this.title,
            this.options,
        );
    }

    removeProperty(key) {
        const newProperties = { ...this.properties };
        delete newProperties[key];
        return new CartItem(
            this.lineNumber,
            this.key,
            this.variantId,
            this.compareAtPrice,
            newProperties,
            this.quantity,
            this.title,
            this.options
        );
    }

    async save() {
        const init = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                line: this.lineNumber,
                quantity: this.quantity,
                properties: this.properties,
            }),
        }
        
        const responseData = await fetch('/cart/change.js', init)
            .then(response => {
                if (!response.ok) {
                    //console.error(response);
                    console.error(`Failed to fetch. status: ${response.status} title: ${this.title}`);
                    throw new Error(message);
                }
                return response.json();
            })
            .catch(error => {
                throw new CartFetchError('Failed to fetch.', this);
            });
        
        const targetItem = responseData.items.find(item => item.variant_id === this.variantId);
        return new CartItem(
            this.lineNumber,
            this.key,
            targetItem.variant_id,
            this.compareAtPrice,
            targetItem.properties,
            this.quantity,
            this.title,
            this.options,
        );
    }
}

class Cart {
    constructor(items) {
        this.items = items;
    }

    async save() {
        const newCartItems = [];
        for (let item of this.items) {
            const newCartItem = await item.save();
            newCartItems.push(newCartItem);
        }
        return new Cart(newCartItems);
    }
}

class CartFactory {
    static generate() {
        const cartElement = document.getElementById('cart');
        const cartItemElements = cartElement.getElementsByClassName('cart-item');

        const cartItems = Array.from(cartItemElements).map(cartItemElement => {
            const jsonItemProperties = cartItemElement.getAttribute('data-item-properties');
            const itemProperties = CartFactory.#convertPropertyFromElementData(jsonItemProperties);

            const jsonOptions = cartItemElement.getAttribute('data-variant-options');
            let options = [];
            if (jsonOptions != null || jsonOptions !== '') {
                options = JSON.parse(jsonOptions);
            }

            let cartItem = new CartItem(
                cartItemElement.getAttribute('data-item-index'),
                cartItemElement.getAttribute('data-item-key'),
                cartItemElement.getAttribute('data-variant-id'),
                cartItemElement.getAttribute('data-variant-compareAtPrice'),
                itemProperties,
                this.#getQuantity(cartItemElement.id),
                cartItemElement.getAttribute('data-item-title'),
                options,
            );

            if (cartItem.compareAtPrice != null) {
                cartItem = cartItem.addProperty(COMPARE_AT_PRICE, cartItem.compareAtPrice);
            } else {
                cartItem = cartItem.removeProperty(COMPARE_AT_PRICE);
            }

            return cartItem;
        });
        return new Cart(cartItems);
    }

    static #getQuantity(id) {
        const cartItemTd = document.getElementById(id);
        const val = cartItemTd.querySelector('.quantity__input').value;
        return Number.parseInt(val);
    }

    static #convertPropertyFromElementData(jsonData) {
        const parsed = JSON.parse(jsonData);
        if (!Array.isArray(parsed)) {
            return {};
        }

        let result = {};
        parsed.map(parsedProperty => {
            const key = parsedProperty[0];
            const value = parsedProperty[1];
            result = { ...result, [key]: value };
        });
        return result;
    }
}

window.addEventListener('DOMContentLoaded', function () {

    // 割引前価格をカートのLinePropertyへ登録する
    if (checkoutButton = document.getElementById('checkout')) {
        let canSubmit = true;
        checkoutButton.addEventListener('click', async function (event) {
            if (!canSubmit) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation(); // EasyPointsほかのイベント処理を一度止め、カート更新を優先させる

            checkoutButton.style.cursor = 'progress';
            canSubmit = false;
            checkoutButton.setAttribute("disabled", true);
            checkoutButton.classList.add('disabled');
            try {
                let cart = CartFactory.generate();
                await cart.save();

                checkoutButton.removeAttribute("disabled");
                checkoutButton.click();
                checkoutButton.setAttribute("disabled", true);
            } catch (error) {
                if (error instanceof CartFetchError) {
                    const productTitle = error.cartItem.title;
                    const errMsg = (window.choverchord.cart.errors.out_of_stock).replace('[product_title]', productTitle);
                    alert(errMsg);
                } else {
                    alert(window.choverchord.cart.errors.unexpected);
                }
                canSubmit = true;
                checkoutButton.style.cursor = '';
                checkoutButton.classList.remove('disabled');
                checkoutButton.removeAttribute("disabled");
            }
        });
    }
});